import { VStack } from "@gluestack-ui/themed";

import { BiometryValidationController } from "./controller";
import { UnicoView } from "@repo/core/components/core/UnicoView";
import { Text } from "@gluestack-ui/themed";
import Spinner from "@repo/core/components/core/Spinner";
import Scaffolds from "@repo/core/components/layout/Scaffolds";

export const BiometryValidation = () => {
  const {
    back,
    statusMessage,
    isFinishedValidation,
    validationURL,
    token,
    processId,
    handleOnFinishValidation
  } = BiometryValidationController();

  return (
    <Scaffolds.Root title="Validação Biometrica" onBackPress={back}>
      <VStack
        flex={1}
        w="$full"
        mb="$4"
        px="$6"
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
      >
        {validationURL && !isFinishedValidation ? (
          <UnicoView
            url={validationURL}
            onFinished={handleOnFinishValidation}
            processId={processId}
            token={token}
          />
        ) : (
          <>
            <Spinner />
            <Text mt="$4" textAlign="center">
              {statusMessage}
            </Text>
          </>
        )}
      </VStack>
    </Scaffolds.Root>
  );
};
